import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { SortDirection } from '../../../../../constans/common-constants';
import { AttendeeSortFields } from '../../../../../constans/attendee-enums';

export interface IAttendeeCell {
    onSort: (name: AttendeeSortFields) => void;
    title: string;
    cellWrapperClass: string;
    name: AttendeeSortFields;
    isActive?: boolean;
    shouldSort?: boolean;
    sortType?: SortDirection | null;
}

const AttendeeCell: FC<IAttendeeCell> = observer(({ onSort, shouldSort, sortType, title, cellWrapperClass, name, isActive }) => {
  const sortActiveCls = `triangle ${shouldSort && isActive? sortType?.toLowerCase() : ''}`;
  const cellWrapperCls = `cell-wrapper ${cellWrapperClass} ${isActive ? 'blue-cell' : 'grey-cell'}`;

  return (
    <div className='table-row-data'>
      <div
        className={cellWrapperCls}
        accessKey={name}
        onClick={(event: React.MouseEvent<HTMLElement>) => onSort((event.target as HTMLDivElement).accessKey as AttendeeSortFields)}
      >
        {title}
        {shouldSort && <span className={sortActiveCls}/>}
      </div>
    </div>
  );
});

export { AttendeeCell };